import Team from "./TeamPage"

export default Team
